import React from "react"
import { navigate } from "gatsby"
import { ArrowRight } from "@phosphor-icons/react"

const NotFoundBadge = ({ title, subtitle, buttonLabel, buttonLink }) => {
  return (
    <React.Fragment>
      <div className="w-full flex flex-wrap border border-[#E7E7E7] rounded-md p-4 gap-y-6 gap-x-7 items-center">
        <div className="flex-1 basis-full md:basis-0">
          <p className="text-md">{title}</p>
          <p className="text-xs text-[#5D5D5D]">
            {subtitle}
          </p>
        </div>
        <button
          className="flex flex-nowrap gap-x-1 items-center underline underline-offset-2"
          onClick={() => navigate(buttonLink)}
          aria-label={buttonLabel}
        >
          <span className="">{buttonLabel}</span>
          <ArrowRight size={16} weight="light" />
        </button>
      </div>
    </React.Fragment>
  );
};

export default NotFoundBadge
